import vaderVsLuke from "../../images/vader-vs-luke.jpg";
import theForceUnleashed from "../../images/theForceUnleashed.jpg";
import fallenOrder from "../../images/fallenOrder.jpg";
import skywalkerSaga from "../../images/skywalkerSaga.jpg";
import outlaws from "../../images/outlaws.jpg";
import Section from "./section";
import vaderComic from "../../images/darth-vader-comic.jpg";
import riseEmpire from "../../images/riseEmpire.jpg";
import heirJedi from "../../images/heirJedi.jpg";
import masterAprrentice from "../../images/master&apprentice.jpg";
import battlefront from "../../images/battlefront.jpg";
import vaderBack from '../../images/vader-back.jpg';
import yoda from "../../images/yoda.jpg";
import plagueis from '../../images/plagueis.jpg'
import kylo from '../../images/kylo.jpg';
import lukeSkywalker from "../../images/lukeSkywalker.jpg";
const HomeMain = () => {
    //functions

    return (
        <>
            <main className="home-main">

                <Section sectionName="historias" gen="a" imageBanner={vaderVsLuke} itemOne={vaderComic} itemTwo={riseEmpire} itemThree={heirJedi} itemFour={masterAprrentice} sectionNumber={0} side1="dark" side2="dark" id0={1} id1={2} id2={3} id3={4}/>

                <Section sectionName="videojuegos" gen="o"  imageBanner={battlefront} itemOne={theForceUnleashed} side1="dark" itemTwo={fallenOrder} itemThree={skywalkerSaga} itemFour={outlaws} sectionNumber={1} id0={0} id1={2} id2={1} id3={3} />
                <Section sectionName="personajes" gen="o"  imageBanner={vaderBack} itemOne={lukeSkywalker} itemTwo={yoda} itemThree={plagueis} itemFour={kylo} sectionNumber={2} side3="dark" side4="dark" side2="green" id0={0} id1={1} id2={3} id3={2} />
            </main>
        </>
    )
}

export default HomeMain;